import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import BaseModal from '../Modals/BaseModal';
import sentry from '../../utils/sentry';

require('./Modal.scss');
require('./ConfirmModal.scss');
import { SUBMIT_MODAL_SETTINGS } from '../../styles/modalSettings';

class ConfirmModal extends Component {
	constructor(props) {
		super(props);
		this.confirm = this.confirm.bind(this);
		this.abort = this.abort.bind(this);
		this.close = this.close.bind(this);
	}
	close() {
		if(this.props.isAlert) {
			this.confirm()
		} else {
			this.abort();
		}
	}
	confirm() {
		this.props.resolve();
	}
	abort() {
		this.props.reject();
	}
	render() {
		return (
			<BaseModal
				isOpen={true}
				title={this.props.title}
				hasCloseButton={false}
				shouldCloseOnOverlayClick={false}
				containerClass='modalConfirm defaultModal'
				onRequestClose={ () => this.close() }
				style={ SUBMIT_MODAL_SETTINGS }
			>
				<div className="container-fluid">
					<div className="row">
						<div className="col-sm-6 col-sm-offset-3 text-center message">
							{this.props.message}
						</div>
					</div>
					<div className="row actions">
						<div className="col-sm-8 col-sm-offset-2 text-center">
							{!this.props.isAlert && <button className="btn-delete" onClick={ this.abort } >{this.props.abortText}</button>}
							<button className="btn-submit" onClick={ this.confirm } >{this.props.isAlert ? this.props.alertText : this.props.confirmText}</button>
						</div>
					</div>
				</div>
			</BaseModal>
		);
	}
}

ConfirmModal.defaultProps = {
	title: 'Notice',
	confirmText: 'Yes',
	abortText: 'No',
	alertText: 'Ok'
};

const confirm = (message, options = {}) => {
	const props = {message: message, ...options};
	const wrapper = document.body.appendChild(document.createElement('div'));
	const cleanup = () => {
		ReactDOM.unmountComponentAtNode(wrapper);
		setTimeout(() => {
			if (wrapper.removeNode) {
				return wrapper.removeNode(true);
			}
			return wrapper.remove();
		});
	};

	const promise = new Promise((resolve, reject) => {
		try {
			ReactDOM.render(
				<ConfirmModal
					reject={reject}
					resolve={resolve}
					cleanup={cleanup}
					{...props}
				/>,
				wrapper
			);
		} catch (e) {
			sentry.logException(e);
			throw e;
		}
	});

	return promise.then((result) => {
		cleanup();
		return result;
	}, (result) => {
		cleanup();
		return Promise.reject(result);
	});

};

const alert = (message, options = {}) => {
	options = {isAlert: true, title: 'Error', ...options};
	return confirm(message, options);
};

export { alert };

export default confirm;



// WEBPACK FOOTER //
// ./app/components/Modals/ConfirmModal.jsx